import { OmyConst } from "../OmyConst";
import Omy from "../Omy";
import OMath from "../utils/OMath";

export default class OContainer extends PIXI.Container {
    constructor() {
        super();

        this._onKillEvent = "kill_event";
        this._onReviveEvent = "revive_event";
        this._onDestroyEvent = "destroy_event";
        this._onDownEvent = "down_event";
        this._onUpEvent = "up_event";
        this._onUpOutSideEvent = "up_out_event";
        this._onOverEvent = "over_event";
        this._onOutEvent = "out_event";
        this._onDragStartEvent = "drag_start_event";
        this._onDragStopEvent = "drag_stop_event";
        this._onDragUpdateEvent = "drag_update_event";


        if (Omy.debugMode) {
            this._isOnDebugerUpdate = true;
            Omy.addUpdater(this._updateDebug, this);
        }
        this._isUpdate = false;
        this.aa_isRegOnDebug = false;
        this._inDebug = false;
        /**         * @type {Object}         */
        this.userData = null;
        /**         * @type {Boolean}         */
        this._active = true;
        this.numChildren = 0;
        this._oX = 0;
        this._oY = 0;
        this._oWidth = 0;
        this._oHeight = 0;
        this._isAlign = false;
        this.aa_alignX = -1;
        this.aa_alignY = -1;
        this.aa_alignEdit = false;
        this.aa_alignUpdate = false;

        /**         * @type {Array}         */
        this._externalMethodParams = null;
        /**         * @type {Function}         */
        this._externalMethod = null;
        this._isDrag = false;
        this._dragVertical = false;
        this._dragHorizontal = false;
        this._isStartDrag = false;
        this._isCheckInput = false;
        this._soundUp = null;
        this._soundOver = null;

        this.autoReviveChildren = true;
        this.needAutoRevive = false;

        this._boundsRect = new OmyConst.Rectangle();
        this._localBoundsRect = new OmyConst.Rectangle();

        this._anchorX = 0;
        this._anchorY = 0;
        this._newAlign = false;
        this._alignAutoUpdate = false;

        this._oType = OmyConst.OMY_CONTAINER;

        this.name = "g_" + OMath.uniqueID();
    }

    /**     * @private     */
    _updateDebug() {
        if (this.aa_isRegOnDebug && !this._inDebug) {
            Omy.add.regDebugMode(this);
        } else if (!this.aa_isRegOnDebug && this._inDebug) {
            Omy.add.removeFromDebug(this);
        }
        if (this._isAlign) {
            if (this.aa_alignUpdate) {
                this.alignContainer();
                this.aa_alignUpdate = false;
            }
            if (this.aa_alignEdit) {
                if (this._alignRect) {
                    this._alignRect.alpha = 0.4;
                    this._alignRect.visible = true;
                } else {
                    this._alignRect = Omy.add.rectJson(null,
                        {
                            x: 0,
                            y: 0,
                            width: 10,
                            height: 10,
                            alpha: 0.4
                        });
                    this.addChildAt(this._alignRect, 0);
                }
                Omy.add.rectJson(this,
                    {
                        x: -5,
                        y: -5,
                        width: 10,
                        height: 10,
                        alpha: 1
                    });
                this.aa_alignEdit = false;
            }
            if (this.aa_alignX !== -1) {
                if (this.aa_alignX < 0) this.aa_alignX = 0;
                if (this.aa_alignX > 1) this.aa_alignX = 1;
                this._alignX = this.aa_alignX;
                this.aa_alignX = -1;
                this.alignContainer();
            }
            if (this.aa_alignY !== -1) {
                if (this.aa_alignY < 0) this.aa_alignY = 0;
                if (this.aa_alignY > 1) this.aa_alignY = 1;
                this._alignY = this.aa_alignY;
                this.aa_alignY = -1;
                this.alignContainer();
            }
        }
    }

    /**     * @public     */
    addChild(child) {
        super.addChild(child);
        this.numChildren = this.children.length;
        return child;
    }

    /**     * @public     */
    addChildAt(child, index) {
        super.addChildAt(child, index);
        this.numChildren = this.children.length;
        return child;
    }

    /**     * @public     */
    removeChild(child) {
        super.removeChild(child);
        this.numChildren = this.children.length;
        return child;
    }

    /**     * @public     */
    removeChildAt(index) {
        let child = super.getChildAt(index);
        super.removeChildAt(index);
        this.numChildren = this.children.length;
        return child;
    }

    /**     * @public     */
    removeChildren(beginIndex, endIndex) {
        endIndex = endIndex < this.children.length ? endIndex : this.children.length - 1;
        let children = [];
        for (let index = beginIndex; index <= endIndex; index++) {
            children.push(this.getChildAt(index));
        }
        for (let i in children) {
            this.removeChild(children[i]);
        }
        return children;
    }

    /**     * @public     */
    removeAll() {
        if (this.children != null) {
            while (this.children.length) {
                this.removeChildAt(0);
            }
            this.numChildren = 0;
        }
    }

    /**
     * @param {PIXI.DisplayObject} child
     * @returns {boolean}
     */
    contains(child) {
        if (this.children == null) {
            return false;
        }

        return this.children.indexOf(child) >= 0;
    }

    /**     * @public     */
    kill() {
        if (this._active) {
            this._active = false;
            if (this._isUpdate)
                Omy.removeUpdater(this.update, this);
            if (this._isOnDebugerUpdate) {
                this._isOnDebugerUpdate = false;
                Omy.removeUpdater(this._updateDebug, this);
            }

            if (this.children != null) {
                let i = 0;
                let m = this.numChildren;
                let o;
                while (i < this.numChildren && this.numChildren) {
                    o = this.children[i++];
                    if (o.active && o.kill) {
                        o.kill();
                    }
                    if (m !== this.numChildren) {
                        m--;
                        i--;
                    }
                }
            }

            if (this.input)
                this.input = false;
            this.renderable = false;
            this.emit(this._onKillEvent, this);
        }

        return this;
    }

    /**     * @public     */
    revive() {
        if (!this._active) {
            this._active = true;
            this.renderable = true;
            if (this._isUpdate)
                Omy.addUpdater(this.update, this);
            if (Omy.debugMode && !this._isOnDebugerUpdate) {
                this._isOnDebugerUpdate = true;
                Omy.addUpdater(this._updateDebug, this);
            }

            if (this.children != null) {
                let i = 0;
                let o;
                while (i < this.numChildren) {
                    o = this.children[i++];
                    if ((this.autoReviveChildren || o.needAutoRevive) && !o.active && o.revive) {
                        o.revive();
                    }
                }
            }

            if (this.input)
                this.input = true;
            this.emit(this._onReviveEvent, this);
        }

        return this;
    }

    /**     * @public     */
    destroy(options) {
        options = options || { children: true, texture: false, baseTexture: false };
        this.json = null;
        this._active = false;
        this.userData = null;
        this.numChildren = 0;
        this._boundsRect = null;
        this._localBoundsRect = null;
        this._isDrag = false;
        this._isStartDrag = false;
        if (this._listenMouseUp) {
            this._listenMouseUp = false;
            Omy.mouse.removeUpMouse(this._globalMouseUp, this);
        }
        this._eventData = null;
        this.isUpdate = false;
        if (this._isOnDebugerUpdate) {
            this._isOnDebugerUpdate = false;
            Omy.removeUpdater(this._updateDebug, this);
        }

        if (this.input) {
            this.input = false;
        }
        this.removeAllListeners(this._onDragStartEvent);
        this.removeAllListeners(this._onDragStopEvent);
        this.removeAllListeners(this._onDragUpdateEvent);
        this.removeAllListeners(this._onDownEvent);
        this.removeAllListeners(this._onOutEvent);
        this.removeAllListeners(this._onOverEvent);
        this.removeAllListeners(this._onUpEvent);
        this.removeAllListeners(this._onUpOutSideEvent);
        this.emit(this._onDestroyEvent, this);
        this.removeAllListeners(this._onDestroyEvent);
        this.removeAllListeners(this._onKillEvent);
        this.removeAllListeners(this._onReviveEvent);

        this._externalMethod = null;
        this._externalMethodParams = null;
        this.renderable = false;
        this.visible = false;
        this._alignRect = null;
        this._alignChild = null;
        this._isAlign = false;
        this._alignFormat = null;
        this._soundUp = null;
        this._soundOver = null;

        super.destroy(options);

        return this;
    }

    /**     * @public     */
    update() {
        if (this._isStartDrag) {
            if (this._eventData.global.x !== this._dragSaveX || this._eventData.global.y !== this._dragSaveY) {
                if (this._dragHorizontal) {
                    this.x = this._oX + this._eventData.global.x - this._dragSaveX;

                    if (this._oX < this._dragXMin) {
                        this.x = this._dragXMin;
                    } else if (this._oX > this._dragXMax) {
                        this.x = this._dragXMax;
                    }
                }
                if (this._dragVertical) {
                    this.y = this._oY + this._eventData.global.y - this._dragSaveY;

                    if (this._oY < this._dragYMin) {
                        this.y = this._dragYMin;
                    } else if (this._oY > this._dragYMax) {
                        this.y = this._dragYMax;
                    }
                }
                this._dragSaveX = this._eventData.global.x;
                this._dragSaveY = this._eventData.global.y;
                this.emit(this._onDragUpdateEvent, this);
                if (!Omy.mouse.isDown) this._upOutSide();
            }
        }
        if (this._alignAutoUpdate) {
            if (this._saveAlignWidth !== this._alignChild.width ||
                this._saveAlignHeight !== this._alignChild.height) {
                this._saveAlignWidth = this._alignChild.width;
                this._saveAlignHeight = this._alignChild.height;
                this.alignContainer();
            }
        }
    }

    _down(event) {
        if (this._isDrag) {
            this._eventData = event.data;
            this._dragSaveX = this._eventData.global.x;
            this._dragSaveY = this._eventData.global.y;
            this._isStartDrag = true;
            this.emit(this._onDragStartEvent, this);
        }

        this.emit(this._onDownEvent, this);
    }

    _over() {
        this.emit(this._onOverEvent, this);
        if (this._soundOver) Omy.sound.play(this._soundOver);
    }

    _out() {
        this.emit(this._onOutEvent, this);
    }

    _upOutSide() {
        this._out();
        this.emit(this._onUpOutSideEvent, this);
    }

    _up() {
        this.emit(this._onUpEvent, this);
        if (this._soundUp) Omy.sound.play(this._soundUp);
        if (this._externalMethod != null)
            this._externalMethod.apply(null, this._externalMethodParams);
    }

    _globalMouseUp() {
        if (this._isDrag && this._isStartDrag) {
            this._eventData = null;
            this._isStartDrag = false;
            this.emit(this._onDragStopEvent, this);
        }
    }

    /**
     * @param {String} aVariableName
     * @param {Object} aValue
     */
    setAll(aVariableName, aValue) {
        let i = 0;
        let o;
        while (i < this.numChildren) {
            o = this.children[i++];
            if (o != null) {
                o[aVariableName] = aValue;
            }
        }
    }

    /**
     * @param {String} aFunctionName
     * @param {Array} aArgs
     */
    callAll(aFunctionName, aArgs = null) {
        if (this.children != null) {
            let i = 0;
            let m = this.numChildren;
            let o;
            while (i < this.numChildren && this.numChildren) {
                o = this.children[i++];
                if (o && o[aFunctionName]) {
                    o[aFunctionName].apply(o, aArgs);
                }
                if (m !== this.numChildren) {
                    m--;
                    i--;
                }
            }
        }
    }

    setXY(ax, ay) {
        this._oX = ax;
        this._oY = ay;
        this.position.set(ax, ay);
    }

    setSize(ax, ay) {
        this.width = ax;
        this.height = ay;
    }

    setScale(ax, ay) {
        this.scale.set(ax, ay);
    }

    setAnchor(ax, ay) {
        this.anchorX = ax;
        this.anchorY = ay;
    }

    setPivot(ax, ay) {
        OMY.Omy.error("old method. not work");
        // this.pivot.set(ax, ay);
        // this.x = this._oX + ax;
        // this.y = this._oY + ay;
    }

    updateAnchor() {
        this.anchorX = this.anchorX;
        this.anchorY = this.anchorY;
    }

    /**
     * @param {Function}eMethod
     * @param {Array}methodParams
     */
    externalMethod(eMethod, methodParams) {
        if (!this.input)
            this.input = true;
        this._externalMethod = eMethod;
        this._externalMethodParams = methodParams;
    }

    boundsDragRect(rXMin = NaN, rYMin = NaN, rXMax = NaN, rYMax = NaN) {
        if (!isNaN(rXMin))
            this._dragXMin = rXMin;
        if (!isNaN(rYMin))
            this._dragYMin = rYMin;
        if (!isNaN(rXMax))
            this._dragXMax = rXMax;
        if (!isNaN(rYMax))
            this._dragYMax = rYMax;
    }

    addOver(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onOverEvent, func, context, once);
    }

    addOut(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onOutEvent, func, context, once);
    }

    addDown(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onDownEvent, func, context, once);
    }

    addUp(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onUpEvent, func, context, once);
    }

    addUpOutSide(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onUpOutSideEvent, func, context, once);
    }

    addDragUpdate(func, context, once) {
        this._addNewEvent(this._onDragUpdateEvent, func, context, once);
    }

    addDragStart(func, context, once) {
        this._addNewEvent(this._onDragStartEvent, func, context, once);
    }

    addDragStop(func, context, once) {
        this._addNewEvent(this._onDragStopEvent, func, context, once);
    }

    addKill(func, context, once) {
        this._addNewEvent(this._onKillEvent, func, context, once);
    }

    addRevive(func, context, once) {
        this._addNewEvent(this._onReviveEvent, func, context, once);
    }

    addDestroy(func, context, once) {
        this._addNewEvent(this._onDestroyEvent, func, context, once);
    }

    _addNewEvent(event, func, context, once = false) {
        if (once)
            this.once(event, func, context);
        else
            this.on(event, func, context);
    }

    removeOver(func, context) {
        this.removeListener(this._onOverEvent, func, context);
    }

    removeOut(func, context) {
        this.removeListener(this._onOutEvent, func, context);
    }

    removeDown(func, context) {
        this.removeListener(this._onDownEvent, func, context);
    }

    removeUp(func, context) {
        this.removeListener(this._onUpEvent, func, context);
    }

    removeUpOutSide(func, context) {
        this.removeListener(this._onUpOutSideEvent, func, context);
    }

    removeDragUpdate(func, context) {
        this.removeListener(this._onDragUpdateEvent, func, context);
    }

    removeDragStart(func, context) {
        this.removeListener(this._onDragStartEvent, func, context);
    }

    removeDragStop(func, context) {
        this.removeListener(this._onDragStopEvent, func, context);
    }

    removeKill(func, context) {
        this.removeListener(this._onKillEvent, func, context);
    }

    removeRevive(func, context) {
        this.removeListener(this._onReviveEvent, func, context);
    }

    removDestroy(func, context) {
        this.removeDestroy(func, context);
    }

    removeDestroy(func, context) {
        this.removeListener(this._onDestroyEvent, func, context);
    }

    setToCenter() {
        this.updateTransform();
        const r = this.getLocalBounds();
        let left = r.x;
        let right = r.x + r.width;
        let top = r.y;
        let bottom = r.y + r.height;
        let e;

        if (this.children != null) {
            let i = 0;
            while (i < this.numChildren) {
                e = this.children[i++];
                e.updateTransform();

                if (e.x < left) {
                    left = e.x;
                }
                if (e.x + e.width > right) {
                    right = e.x + e.width;
                }

                if (e.y < top) {
                    top = e.y;
                }

                if (e.y + e.height > bottom) {
                    bottom = e.y + e.height;
                }
            }
        }

        const localWidth = right - left;
        const localHeight = bottom - top;

        let stepX = -localWidth * 0.5 - left;
        let stepY = -localHeight * 0.5 - top;

        if (this.children != null) {
            let i = 0;
            while (i < this.numChildren) {
                this.e = this.children[i++];

                this.e.x += stepX;
                this.e.y += stepY;
            }
        }

        this.x -= stepX;
        this.y -= stepY;
    }

    newAlignContainer(format) {
        if (!format) return;
        if (this._alignFormat === format) return;
        this._alignFormat = format;
        if (this._newAlign) {
            this._updateAlignConfig();
            return;
        }
        this._alignX = format["x"] || 0;
        this._alignY = format["y"] || 0;
        this._alignRect.alpha = (format["edit"]) ? 0.4 : 0;
        this._alignRect.visible = format["edit"];
        this.alignContainer();
    }

    createAlign(format) {
        this._isAlign = true;
        this._alignFormat = format;
        this._alignX = format["x"] || 0;
        this._alignY = format["y"] || 0;
        /** @type {OGraphic} */
        this._alignRect = Omy.add.rectJson(null,
            {
                x: 0,
                y: 0,
                width: 10,
                height: 10
            });
        this._alignRect.alpha = (format["edit"]) ? 0.4 : 0;
        this._alignRect.visible = format["edit"];
        /** @type {OContainer} */
        this._alignChild = Omy.add.container(null);
        this._alignChild.name = "canvas";
        while (this.children.length) {
            this._alignChild.addChild(this.removeChildAt(0));
        }
        this.addChild(this._alignRect);
        this.addChild(this._alignChild);
        this.alignContainer();
    }

    alignContainer() {
        this.callAll("alignContainer");
        if (this._isAlign) {
            if (this._newAlign) {
                this._updateAlign();
                return;
            }
            this._alignChild.updateTransform();
            const r = this._alignChild.getLocalBounds();
            let left = r.x;
            let top = r.y;
            let localWidth = r.width;
            let localHeight = r.height;

            if (this._alignFormat.hasOwnProperty("rect")) {
                this._alignRect.width = this._alignFormat["rect"]["width"];
                this._alignRect.height = this._alignFormat["rect"]["height"];
                this._alignChild.scale.set(1);
                if (this._alignRect.width < localWidth ||
                    this._alignRect.height < localHeight) {
                    const scX = this._alignRect.width / localWidth;
                    const scY = this._alignRect.height / localHeight;
                    const scale = Math.min(scX, scY);
                    left *= scale;
                    top *= scale;
                    localWidth *= scale;
                    localHeight *= scale;
                    this._alignChild.scale.set(scale);
                }
            } else {
                this._alignRect.width = localWidth;
                this._alignRect.height = localHeight;
            }

            if (this._alignX >= 0 && this._alignX <= 1) {
                this._alignChild.x = -1 * (left + localWidth * this._alignX);
                this._alignRect.x = -1 * this._alignX * this._alignRect.width;
            }
            if (this._alignY >= 0 && this._alignY <= 1) {
                this._alignChild.y = -1 * (top + localHeight * this._alignY);
                this._alignRect.y = -1 * this._alignY * this._alignRect.height;
            }
        }
    }

    _updateAlignConfig() {
        this._alignX = this._alignFormat["x"] || 0;
        this._alignY = this._alignFormat["y"] || 0;
        this._alignAutoUpdate = (this._alignFormat.hasOwnProperty("autoUpdate")) ? this._alignFormat["autoUpdate"] : false;
        this.alignContainer();
    }

    setAlign(format) {
        this._isAlign = true;
        this._newAlign = true;
        this._alignFormat = format;

        this._alignX = format["x"] || 0;
        this._alignY = format["y"] || 0;
        this._alignAutoUpdate = (format.hasOwnProperty("autoUpdate")) ? format["autoUpdate"] : false;
        if (this._alignAutoUpdate)
            this.isUpdate = true;

        this._alignChild?.destroy();
        /** @type {OContainer} */
        this._alignChild = Omy.add.container(null);
        this._alignChild.name = "canvas";
        while (this.children.length) {
            this._alignChild.addChild(this.removeChildAt(0));
        }
        this.addChild(this._alignChild);
        if (format["edit"]) {
            this._alignRect?.destroy();
            let width = format["rect"]?.width || 10;
            let height = format["rect"]?.height || 10;
            /** @type {OGraphic} */
            this._alignRect = Omy.add.rectJson(null,
                {
                    x: -width * this._alignX,
                    y: -height * this._alignY,
                    width: width,
                    height: height,
                    alpha: 0.4
                });
            this.addChildAt(this._alignRect, 0);
            this._centerPoint = Omy.add.rectJson(this,
                {
                    x: -5,
                    y: -5,
                    width: 10,
                    height: 10,
                    alpha: 1
                });
        }
        this.alignContainer();
    }

    _updateAlign() {
        this._alignChild.updateTransform();
        let r = this._alignChild.getLocalBounds();
        let left = r.x;
        let top = r.y;
        let localWidth = r.width;
        let localHeight = r.height;

        if (this._alignFormat.hasOwnProperty("rect")) {
            this._alignChild.scale.set(1);
            if (this._alignFormat.rect.width < localWidth ||
                this._alignFormat.rect.height < localHeight) {
                const scX = this._alignFormat.rect.width / localWidth;
                const scY = this._alignFormat.rect.height / localHeight;
                const scale = Math.min(scX, scY);
                left *= scale;
                top *= scale;
                localWidth *= scale;
                localHeight *= scale;
                this._alignChild.scale.set(scale);
            }
        } else {
            if (this._alignRect) {
                this._alignRect.clear();
                this._alignRect.beginFill(0x000000, 0.4);
                this._alignRect.drawRect(-localWidth * this._alignX, -localHeight * this._alignY, localWidth, localHeight);
                this._alignRect.endFill();
            }
        }

        if (this._alignX >= 0 && this._alignX <= 1) this.pivot.x = left + localWidth * this._alignX;
        if (this._alignY >= 0 && this._alignY <= 1) this.pivot.y = top + localHeight * this._alignY;
        if (this._centerPoint) {
            this._centerPoint.pivot.x = -1 * this.pivot.x;
            this._centerPoint.pivot.y = -1 * this.pivot.y;
        }
        if (this._alignRect) {
            this._alignRect.pivot.x = -1 * this.pivot.x;
            this._alignRect.pivot.y = -1 * this.pivot.y;
        }
    }

//---------------------------------------
/// ACCESSOR
//--------------------------------------

    set isUpdate(value) {
        if (!this._isUpdate && value) {
            Omy.addUpdater(this.update, this);
        } else if (this._isUpdate && !value) {
            Omy.removeUpdater(this.update, this);
        }
        this._isUpdate = value;
    }

    get isUpdate() {
        return this._isUpdate;
    }

    get active() {
        return this._active;
    }

    get scaleX() {
        return this.scale.x;
    }

    set scaleX(value) {
        this.scale.x = value;
    }

    get scaleY() {
        return this.scale.y;
    }

    set scaleY(value) {
        this.scale.y = value;
    }

    get pivotX() {
        return this.pivot.x;
    }

    set pivotX(value) {
        this.pivot.x = value;
    }

    get pivotY() {
        return this.pivot.y;
    }

    set pivotY(value) {
        this.pivot.y = value;
    }

    set anchorX(value) {
        this._anchorX = value;
        this.pivot.x = value * this.width / this.scale.x;
    }

    get anchorX() {
        return this._anchorX;
    }

    set anchorY(value) {
        this._anchorY = value;
        this.pivot.y = value * this.height / this.scale.y;
    }

    get anchorY() {
        return this._anchorY;
    }

    get localLeft() {
        return this._localBoundsRect.left;
    }

    get localRight() {
        return this._localBoundsRect.right;
    }

    get localTop() {
        return this._localBoundsRect.top;
    }

    get localBottom() {
        return this._localBoundsRect.bottom;
    }

    get localWidth() {
        return this._localBoundsRect.width;
    }

    get localHeight() {
        return this._localBoundsRect.height;
    }

    get globalLeft() {
        return this.getGlobalPosition().x + this.localLeft;
    }

    get globalTop() {
        return this.getGlobalPosition().y + this.localTop;
    }

    get worldX() {
        return this.getGlobalPosition().x;
    }

    get worldY() {
        return this.getGlobalPosition().y;
    }

    get x() {
        this._oX = super.x;
        return this._oX;
    }

    set x(value) {
        super.x = this._oX = value;
    }

    get y() {
        this._oY = super.y;
        return this._oY;
    }

    set y(value) {
        super.y = this._oY = value;
    }

    get height() {
        this._oHeight = super.height;
        return this._oHeight;
    }

    set height(value) {
        return super.height = this._oHeight = value;
    }

    get width() {
        this._oWidth = super.width;
        return this._oWidth;
    }

    set width(value) {
        return super.width = this._oWidth = value;
    }

    get oType() {
        return this._oType;
    }

    get input() {
        return this._isCheckInput;
    }

    set input(value) {
        if (this.input) {
            this.interactive = value;
        } else if (value) {
            this._isCheckInput = true;
            this.interactive = true;
            this.on("pointerdown", this._down, this);
            this.on("pointerup", this._up, this);
            this.on("pointerupoutside", this._upOutSide, this);
            this.on("pointerover", this._over, this);
            this.on("pointerout", this._out, this);
        }
    }

    set drag(value) {
        if (!this.input)
            this.input = true;

        if (!this._isUpdate) this.isUpdate = true;

        this._isDrag = value;
        this._listenMouseUp = value;
        (this._listenMouseUp) ? Omy.mouse.addUpHandler(this._globalMouseUp, this) : Omy.mouse.removeUpMouse(this._globalMouseUp, this);
        this._dragVertical = true;
        this._dragHorizontal = true;
    }

    set allowHorizontalDrag(value) {
        this._dragHorizontal = value;
    }

    set allowVerticalDrag(value) {
        this._dragVertical = value;
    }

    set interactChild(value) {
        this.interactiveChildren = value;
    }

    get isAlign() {
        return this._isAlign;
    }

    /**
     * @returns {OContainer}
     */
    get canvas() {
        return (this._alignChild) ? this._alignChild : this;
    }

    set alignX(value) {
        this._alignX = value;
    }

    get alignX() {
        return this._alignX;
    }

    set alignY(value) {
        this._alignY = value;
    }

    get alignY() {
        return this._alignY;
    }

    set soundUp(value) {
        this._soundUp = value;
    }

    set soundOver(value) {
        this._soundOver = value;
    }
}
